$.components.register("datepicker", {
  mode: "default",
  defaults: {
    autoclose: true,
      format: 'dd-mm-yyyy',
      orientation: 'bottom auto'
  }
});
